import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly LANG_KEY = 'user_lang';
  private currentLang = 'es';

  constructor(
    private translate: TranslateService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.initLanguage();
  }

  private initLanguage(): void {
    this.translate.addLangs(['es', 'en']);
    this.translate.setFallbackLang('es');

    if (isPlatformBrowser(this.platformId)) {
      const savedLang = localStorage.getItem(this.LANG_KEY);
      if (savedLang) {
        this.currentLang = savedLang;
      } else {
        const browserLang = navigator.language.split('-')[0];
        this.currentLang = browserLang.match(/en|es/) ? browserLang : 'es';
      }
      document.documentElement.lang = this.currentLang;
    }

    this.translate.use(this.currentLang);
  }

  public setLanguage(lang: string): void {
    this.currentLang = lang;
    this.translate.use(lang);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.LANG_KEY, lang);
      document.documentElement.lang = lang;

      // TODO: Actualizar en el backend cuando el usuario esté autenticado
      // ej: this.userService.updateLanguage(lang).subscribe();
    }
  }

  public getCurrentLanguage(): string {
    return this.currentLang;
  }
}
